var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{on:{"click":function($event){return _vm.$emit('click' )}}},[_c('v-card-text',[_c('provider-subscription',{ref:"subscriptionForm"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }